import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const LOGO_URL = 'https://vhnuplacedgmgryjrjhn.supabase.co/storage/v1/object/public/cms-images/logo_dario_trans.png';

const navItems = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const useSolidStyle = scrolled || !isHomePage;

  useEffect(() => {
    if (!isHomePage) {
      setScrolled(true);
      return;
    }

    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);

    if (!isHomePage) {
      navigate({ pathname: '/', hash: href });
      return;
    }

    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        useSolidStyle ? 'bg-white/95 backdrop-blur-sm shadow-sm py-2' : 'bg-transparent py-3'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src={LOGO_URL}
            alt="Logo Nutricionista"
            className="h-12 w-auto object-contain"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className={`text-sm font-medium tracking-wide uppercase transition-colors duration-200 cursor-pointer hover:text-[#8B9D83] ${
                useSolidStyle ? 'text-[#1A1A1A]' : 'text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#agendar"
            onClick={(e) => handleNavClick(e, '#agendar')}
            className="bg-[#8B9D83] text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-[#6B7D63] transition-colors cursor-pointer whitespace-nowrap"
          >
            Reservar Cita
          </a>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer ${useSolidStyle ? 'text-[#1A1A1A]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-3">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="text-sm font-medium text-[#1A1A1A] hover:text-[#8B9D83] py-1 cursor-pointer uppercase tracking-wide"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#agendar"
            onClick={(e) => handleNavClick(e, '#agendar')}
            className="mt-2 bg-[#8B9D83] text-white text-sm font-semibold px-5 py-3 rounded-full hover:bg-[#6B7D63] transition-colors cursor-pointer whitespace-nowrap text-center"
          >
            Pedir Cita
          </a>
        </div>
      )}
    </nav>
  );
}
